var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14063_55078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5C2.45 5.5 2 5.05 2 4.5C2 3.95 2.45 3.5 3 3.5C3.55 3.5 4 3.95 4 4.5C4 5.05 3.55 5.5 3 5.5ZM7 4.5C7 3.95 6.55 3.5 6 3.5C5.45 3.5 5 3.95 5 4.5C5 5.05 5.45 5.5 6 5.5C6.55 5.5 7 5.05 7 4.5ZM10 4.5C10 3.95 9.55 3.5 9 3.5C8.45 3.5 8 3.95 8 4.5C8 5.05 8.45 5.5 9 5.5C9.55 5.5 10 5.05 10 4.5ZM8 7.5C8 8.05 8.45 8.5 9 8.5C9.55 8.5 10 8.05 10 7.5C10 6.95 9.55 6.5 9 6.5C8.45 6.5 8 6.95 8 7.5ZM7 7.5C7 6.95 6.55 6.5 6 6.5C5.45 6.5 5 6.95 5 7.5C5 8.05 5.45 8.5 6 8.5C6.55 8.5 7 8.05 7 7.5ZM4 7.5C4 6.95 3.55 6.5 3 6.5C2.45 6.5 2 6.95 2 7.5C2 8.05 2.45 8.5 3 8.5C3.55 8.5 4 8.05 4 7.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14063_55078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicator);
export default __webpack_public_path__ + "static/media/DragIndicator.676f318d0db54fcaf0cac0259801e94d.svg";
export { ForwardRef as ReactComponent };